import { useContext } from "react";
import { AuthContext } from "../contex/AuthProvider";

const { Navigate, useLocation } = require("react-router-dom");
export default function RequireAuth({ children }) {
  let auth = useContext(AuthContext);
  console.log("🚀 ~ RequireAuth ~ auth", auth)
  let location = useLocation();
  console.log(Boolean(auth?.user.login));
  if (auth?.user.login === false) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // than dropping them off on the home page.
    return <Navigate to="/auth" state={{ from: location }} />;
  }
  return children;
}
